import { app } from '@/main';

import ProgramStatus from '@/views/ProgramStatus/ProgramStatus.vue';
import flagKeys from '@/constants/flagKeys';
import { IBusinessType } from '@/models/business';

import { Route } from '../route.model';

const programStatus = new Route(
  '/program-status',
  'program-status',
  ProgramStatus,
  {
    isResponsive: flagKeys.responsiveDashboard,
    requiresAuth: true,
    flag: flagKeys.loyaltyProgramStatus,
    navbar: {
      description:
        'Track your Program status according to each location and card network.'
    },
    pageView: {
      eventLabel: 'Program Status',
      eventProps: () => ({
        'Operation Type':
          (app.$store.getters['startGuide/getPreferences'] || {}).startBy ||
          (app.$store.getters['business/getBusinessState'] || {}).operationType
      })
    },
    feature: {
      type: IBusinessType.BOTH,
      title: 'Loyalty Program',
      icon: 'reward-ratio',
      description:
        'Create happy members and repeat business with this powerful marketing tool.'
    }
  }
);

export { programStatus };
export default programStatus;
